import GLU from '../glu2.js/src/index';

class MetadataApi extends GLU.Api {
  constructor(endpoint) {
    super(endpoint);

    this.createApiActions({
      name: 'getMetadata',
      method: GLU.Api.Get,
      path: '/SpiceMap/data/SeMetadata.ashx',
      credentials: false,
    }, {
      name: 'partialMeta',
      method: GLU.Api.Get,
      path: '/PartialMeta',
      credentials: false,
    }, {
      name: 'dataset',
      method: GLU.Api.Get,
      path: '/Dataset',
      credentials: false,
    }, {
      name: 'table',
      method: GLU.Api.Get,
      path: '/Table',
      credentials: false,
    }, {
      name: 'categoryTables2',
      method: GLU.Api.Get,
      path: '/CategoryTables2',
      credentials: false,
    }, {
      name: 'surveys',
      method: GLU.Api.Get,
      path: '/surveys',
      credentials: false,
    });
  }
}

export default MetadataApi;
